import { createAsyncThunk } from '@reduxjs/toolkit';

import { MyInvestmentsService } from 'api';

import { SortPaginationParams } from 'models';

export const getMyCurrentInvestments = createAsyncThunk(
	'myInvestments/getMyCurrentInvestments',
	async (params: SortPaginationParams) => {
		return await MyInvestmentsService.getCurrent(params);
	},
);
